import siteLayoutToolkitImage from "../../assets/site-layout-toolkit-logo.svg";
import styled,{ keyframes } from "styled-components";
import Image from "../shared/Image";
import React from "react";
import AppContainer from "../shared/AppContainer";

const wipe = keyframes`
  from {
    transform: translateY(-20%);
    opacity : 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const SiteLayoutToolkitLogoContainer = styled.div`
  animation: ${wipe} 0.2s ease-in-out;
`;

const SiteLayoutToolkitHeader = () => {
  return (
    <AppContainer>
      <Image maxHeight="auto" src={siteLayoutToolkitImage} />
    </AppContainer>
  )
}

export default SiteLayoutToolkitHeader;